import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { Dropdown } from '../../interfaces/dropdown.interface';

@Component({
    selector: 'roblex-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
    /**
     * Dropdowns  of dropdown component
     */
    dropdowns: any;
    /**
     * Input options of dropdown component
     */
    @Input() options: Dropdown[];
    /**
     * Input text of dropdown component
     */
    @Input() text: string = 'Title';
    /**
     * Input icon of dropdown component
     */
    @Input() icon: string;
    /**
     * Output event click of dropdown component
     */
    @Output() eventClick: EventEmitter<Dropdown> = new EventEmitter();
    /**
     * View child of dropdown component
     */
    @ViewChild('dropdownContent') dropdownContent: ElementRef;
    /**
     * Creates an instance of dropdown component.
     */
    constructor() {
        //
    }
    /**
     * Determines whether click dropdown on
     */
    onClickDropdown() {
        this.dropdownContent.nativeElement.classList.toggle('show');
        this.eventClick.emit();
    }
    /**
     * Determines whether click option on
     * @param option Dropdown
     */
    onClickOption(option: Dropdown) {
        this.dropdownContent.nativeElement.classList.toggle('show');
        if (option?.callbackAction) {
            option?.callbackAction(option);
        }
    }
    /**
     * Determines whether click outside on
     */
    onClickOutside() {
        if (this.dropdownContent.nativeElement.classList.contains('show')) {
            this.dropdownContent.nativeElement.classList.remove('show');
        }
    }
}
